import React, { Component } from 'react';
import * as d3 from 'd3';
import { formatNumber } from '../helpers/helpers.js';

import './slope.css';

class Slope extends Component {
  constructor(props) {
    super(props);

    this.chart = React.createRef();

    this.draw = this.draw.bind( this );
    this.outputSVG = this.outputSVG.bind( this );
    this.viewbox = this.viewbox.bind( this );

    this.state = {
      "paths": {
        "axis": {},
        "series": []
      },
      "ready": false,
      "size": {
				"h": 0,
				"w": 0
			},
    }
  }

  componentDidMount() {
    this.viewbox();
    window.addEventListener( 'resize', this.viewbox, false );
  }
	
	componentWillUnmount() {
		window.removeEventListener( 'resize', this.viewbox, false );
	}

  draw() {
    const legendHeight = 15;
    const distanceFromAxis = 4;
    const topBaseY = 30;
    const bottomBaseY = this.state.size.h - ( legendHeight * ( this.props.series.length + 3));
    const leftBaseX = 40;
    const rightBaseX = this.state.size.w - leftBaseX;
    let scaleY = d3.scaleLinear()
      .domain( this.props.domain )
      .range( [ bottomBaseY, topBaseY ] );

    let series = [];
    let axis = {
      labels: {
        end: {
          text: this.props.labels[0],
          x: leftBaseX,
          y: (topBaseY / 2)
        },
        start: {
          text: this.props.labels[1],
          x: rightBaseX,
          y: (topBaseY / 2)
        }
      },
      lines: {
        end: {
          labelBottom: {
            text: this.props.domain[0] + this.props.unit,
            x: (rightBaseX + distanceFromAxis),
            y: ( bottomBaseY )
          },
          labelTop: {
            text: this.props.domain[1] + this.props.unit,
            x: (rightBaseX + distanceFromAxis),
            y: ( topBaseY )
          },
          x1: rightBaseX,
          x2: rightBaseX,
          y1: ( bottomBaseY ),
          y2: ( topBaseY )
        },

        start: {
          labelBottom: {
            text: formatNumber(this.props.domain[0]) + this.props.unit,
            x: (leftBaseX - distanceFromAxis),
            y: ( bottomBaseY )
          },
          labelTop: {
            text: formatNumber(this.props.domain[1]) + this.props.unit,
            x: (leftBaseX - distanceFromAxis),
            y: ( topBaseY )
          },
          x1: leftBaseX,
          x2: leftBaseX,
          y1: ( bottomBaseY ),
          y2: ( topBaseY )
        }
      }
    };
    let i = 2;
    this.props.series.forEach(
      (serie) => {
        let path = {
          end: {
            label: {
              text: formatNumber(serie.end) + this.props.unit,
              x: rightBaseX + distanceFromAxis,
              y: scaleY( serie.end )
            }
          },
          id: serie.id,
          legend: {
            line: {
              x1: distanceFromAxis,
              x2: (( rightBaseX - leftBaseX ) / 2) - distanceFromAxis,
              y1: bottomBaseY + ( legendHeight * i ),
              y2: bottomBaseY + ( legendHeight * i )
            },
            label: {
              text: serie.label,
              x: (( rightBaseX - leftBaseX ) / 2) + distanceFromAxis,
              y: bottomBaseY + ( legendHeight * i )
            },
            detail: {
              text: (serie.id !== 'activity') ? formatNumber(serie.start) + this.props.unit : ''
            }
          },
          line: {
            x1: leftBaseX,
            x2: rightBaseX,
            y1: scaleY( serie.start ),
            y2: scaleY( serie.end )
          },
          start: {
            label: {
              text: formatNumber(serie.start) + this.props.unit,
              x: leftBaseX - distanceFromAxis,
              y: scaleY( serie.start )
            }
          }
        };
        series.push( path );
        i++;
      }
    );

    this.setState(
      { paths: { axis, series }, ready: true }
    );
  }

  outputSVG() {
    if ( this.state.ready) {
      return (
        <svg viewport={"0 0 " + this.state.size.w + ' ' + this.state.size.h} preserveAspectRatio="xMidYMid meet" width={this.state.size.w} height={this.state.size.h}>
          <g className="axis">
            <g className="axis--background">
              <path d={"M" + this.state.paths.axis.lines.start.x1 + "," + this.state.paths.axis.lines.start.y1 + " L" + this.state.paths.axis.lines.start.x2 + "," + this.state.paths.axis.lines.start.y2 + " L" + this.state.paths.axis.lines.end.x2 + "," + this.state.paths.axis.lines.end.y2 + " L" + this.state.paths.axis.lines.end.x1 + "," + this.state.paths.axis.lines.start.y1 + "Z"} />
            </g>
            <g className="axis--labels">
              <text
                x={this.state.paths.axis.labels.start.x}
                y={this.state.paths.axis.labels.start.y}>{this.state.paths.axis.labels.start.text}</text>

              <text
                x={this.state.paths.axis.labels.end.x}
                y={this.state.paths.axis.labels.end.y}>{this.state.paths.axis.labels.end.text}</text>
            </g>
            <g className="axis--start">
              <line
                x1={this.state.paths.axis.lines.start.x1}
                x2={this.state.paths.axis.lines.start.x2}
                y1={this.state.paths.axis.lines.start.y1}
                y2={this.state.paths.axis.lines.start.y2} />

              <text
                x={this.state.paths.axis.lines.start.labelTop.x}
                y={this.state.paths.axis.lines.start.labelTop.y}>{this.state.paths.axis.lines.start.labelTop.text}</text>

              <text
                x={this.state.paths.axis.lines.start.labelBottom.x}
                y={this.state.paths.axis.lines.start.labelBottom.y}>{this.state.paths.axis.lines.start.labelBottom.text}</text>

              <circle
                cx={this.state.paths.axis.lines.start.x1}
                cy={this.state.paths.axis.lines.start.y1}
                r="2" />

              <circle
                cx={this.state.paths.axis.lines.start.x2}
                cy={this.state.paths.axis.lines.start.y2}
                r="2" />
            </g>
            <g className="axis--end">
              <line
                x1={this.state.paths.axis.lines.end.x1}
                x2={this.state.paths.axis.lines.end.x2}
                y1={this.state.paths.axis.lines.end.y1}
                y2={this.state.paths.axis.lines.end.y2} />

              <text
                x={this.state.paths.axis.lines.end.labelTop.x}
                y={this.state.paths.axis.lines.end.labelTop.y}>{this.state.paths.axis.lines.end.labelTop.text}</text>

              <text
                x={this.state.paths.axis.lines.end.labelBottom.x}
                y={this.state.paths.axis.lines.end.labelBottom.y}>{this.state.paths.axis.lines.end.labelBottom.text}</text>

              <circle
                cx={this.state.paths.axis.lines.end.x1}
                cy={this.state.paths.axis.lines.end.y1}
                r="2" />

              <circle
                cx={this.state.paths.axis.lines.end.x2}
                cy={this.state.paths.axis.lines.end.y2}
                r="2" />
            </g>
          </g>
          <g className="series">
            {this.state.paths.series.map(
              ( serie ) => {
                return (
                  <g key={serie.id} className={"serie serie-" + serie.id}>
                    <path className="serie--fill"
                      d={'M' + serie.line.x1 + ',' + serie.line.y1 + ' L' + serie.line.x2 + ',' + serie.line.y2 + ' L' + this.state.paths.axis.lines.end.x1 + ',' + this.state.paths.axis.lines.end.y1 + ' L' + this.state.paths.axis.lines.start.x1 + ',' + this.state.paths.axis.lines.start.y1 + 'Z'} />
                    
                    <line
                      x1={serie.line.x1}
                      x2={serie.line.x2}
                      y1={serie.line.y1}
                      y2={serie.line.y2} />

                    <circle
                      cx={serie.line.x1}
                      cy={serie.line.y1}
                      r="2" />
  
                    <circle
                      cx={serie.line.x2}
                      cy={serie.line.y2}
                      r="2" />

                    <text className="serie--label-end"
                      x={serie.end.label.x}
                      y={serie.end.label.y}>{serie.end.label.text}</text>

                    <text className="serie--label-start"
                      x={serie.start.label.x}
                      y={serie.start.label.y}>{serie.start.label.text}</text>

                    <text className="serie--label-middle"
                      x={serie.start.label.x + ((serie.end.label.x - serie.start.label.x) /2)}
                      y={serie.end.label.y}>{serie.end.label.text}</text>

                    <g className="legend">
                      <line
                        x1={serie.legend.line.x1}
                        x2={serie.legend.line.x2}
                        y1={serie.legend.line.y1}
                        y2={serie.legend.line.y2} />

                      <text
                        x={serie.legend.label.x}
                        y={serie.legend.label.y}>
                          <tspan>{serie.legend.label.text} </tspan>
                          <tspan className="data"> {serie.legend.detail.text}</tspan>
                      </text>
                    </g>
                  </g>
                )
              }
            )}
          </g>
        </svg>
      );
    }
    return null;
  }

  viewbox() {
    let svgWrapper = this.chart.current;
    let size = {
      "h": svgWrapper.offsetHeight,
      "w": svgWrapper.offsetWidth,
    }
    this.setState(
      { size },
      () => {
        this.draw();
      }
    );
  }

  render() {
    return (
      <div className="slope" ref={this.chart}>
        {this.outputSVG()}
      </div>
    );
  }
}

export default Slope;


// WEBPACK FOOTER //
// ./src/Elezioni/charts/slope.js